import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
document.addEventListener('contextmenu', function (e) {
  e.preventDefault();
  alert('The website is protected !.you have to build your own $ only different can make a difference$ ');
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
